import { useHistory, useLocation } from 'react-router-dom';
import { getFilterItems, isSearchFilter, isSortFilter } from './filtersUtils';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { useMyPlaylistsParams } from '../myPlaylists';
import { useEffect, useMemo } from 'react';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { FilterItems } from '../../containers/TracksPage/FilterItems';
import { useHasGate } from '../accounts';
export const useFilterOptions = filterType => {
  const [[searchFilter]] = useSearchParam(FILTER_TYPES.SEARCH);
  const hasShortsGate = useHasGate('Academy:ShortFormContent');
  return useMemo(() => {
    const options = getFilterItems(filterType, searchFilter);
    if (!hasShortsGate) return options.filter(option => option !== 'SHORT_FORM_CONTENT');
    return options;
  }, [filterType, hasShortsGate, searchFilter]);
};
export const useDefaultFilterValue = (paramValue, filterType) => {
  const {
    tab
  } = useMyPlaylistsParams();
  return useMemo(() => {
    if (paramValue.length) return paramValue;
    switch (filterType) {
      case 'assignedBy':
        return ['EVERYONE'];
      case 'myPlaylistsType':
        return [tab];
      default:
        return [];
    }
  }, [filterType, paramValue, tab]);
};
export const useSearchFilter = enabledFilters => enabledFilters.find(isSearchFilter);
export const useSortFilter = enabledFilters => enabledFilters.find(isSortFilter);

/** Clears filter search params from the url that are invalid. This happens when
 * state changes on a certain page change that updates the list of valid items in
 * a certain filter (f.e sorting on My Playlists when changing search) */
export const useGuardFilterParams = () => {
  const location = useLocation();
  const history = useHistory();
  const [[searchFilter]] = useSearchParam(FILTER_TYPES.SEARCH);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const filtersToRemove = [];
    Array.from(searchParams.keys()).forEach(searchParam => {
      const filterType = searchParam;
      const filterValue = searchParams.get(searchParam);
      if (!filterValue || !FilterItems[filterType] || isSearchFilter(filterType)) return;

      // checks if valid filter items has the current filter value
      if (!getFilterItems(filterType, searchFilter).includes(filterValue)) {
        filtersToRemove.push(filterType);
      }
    });

    // removes invalid filter values from URL if any
    if (filtersToRemove.length) {
      filtersToRemove.forEach(filterToRemove => searchParams.delete(filterToRemove));
      history.push(Object.assign({}, location, {
        search: searchParams.toString()
      }));
    }
  }, [history, location, searchFilter]);
};